module.exports = __webpack_public_path__ + "img/search_o.800a768d.svg";